/* =============================================================================
   Feeding Guide Quiz — JavaScript
   =============================================================================
   Architecture:
     FeedingCalculator  — pure calculation functions, no DOM
     FeedingGuideQuiz   — modal lifecycle, navigation, validation, rendering
   ============================================================================= */

'use strict';

/* ---------------------------------------------------------------------------
   Constants — isolated so the formula is easy to update in future
   --------------------------------------------------------------------------- */
   var handle = window.location.pathname.split('/').pop();
if(handle == 'hearty-hotpot' || handle == 'farmhouse-feast' || handle == 'superfood-supper') {
  var wetArray = [1, 2, 3];
  var wetWithDryArray = [1];
} else {
  var wetArray = [0, 1, 2];
  var wetWithDryArray = [0];
}
var FGQ_CONSTANTS = {
  DRY_KCAL_PER_GRAM: 3.54,
  WET_KCAL_PER_GRAM: 1.24,
  WET_TRAY_GRAMS: 390,

  MER_FACTORS: {
    'Bit Chunky': {
      'Yes': { 'Snoozer': 1.10, 'Mover': 1.15, 'Zoomer': 1.20 },
      'No':  { 'Snoozer': 1.20, 'Mover': 1.25, 'Zoomer': 1.30 }
    },
    'Just Right': {
      'Yes': { 'Snoozer': 1.40, 'Mover': 1.50, 'Zoomer': 1.50 },
      'No':  { 'Snoozer': 1.50, 'Mover': 1.60, 'Zoomer': 1.70 }
    },
    'Lean Machine': {
      'Yes': { 'Snoozer': 1.70, 'Mover': 1.70, 'Zoomer': 1.80 },
      'No':  { 'Snoozer': 1.70, 'Mover': 1.70, 'Zoomer': 1.80 }
    }
  },

  // Static badge assignments by variant index (0-based)
  DRY_BADGES: { 1: 'Most Popular', 2: 'Best Value' },

  // Variants shown per food type [variantIndices]
  FOOD_TYPE_VARIANTS: {
    'Dry Food':  { dry: [0, 1, 2], wet: [] },
    'Wet Food':  { dry: [],        wet: wetArray },
    'Wet + Dry': { dry: [1, 2],    wet: wetWithDryArray }
  }


};

/* ---------------------------------------------------------------------------
   FeedingCalculator — pure calculation module
   --------------------------------------------------------------------------- */

var FeedingCalculator = (function (C) {

  function calculateRER(weightKg) {
    return 70 * Math.pow(weightKg, 0.75);
  }

  function getMERFactor(bodyCondition, neutered, activity) {
    var table = C.MER_FACTORS[bodyCondition];
    if (!table) return null;
    var row = table[neutered];
    if (!row) return null;
    return row[activity] || null;
  }

  function calculateTotalKcal(weightKg, bodyCondition, neutered, activity) {
    var rer = calculateRER(weightKg);
    var mer = getMERFactor(bodyCondition, neutered, activity);
    if (mer === null) return null;
    return rer * mer;
  }

  function calculateGramsPerDay(totalKcal, foodType) {
    if (foodType === 'Dry Food') {
      return { dry: totalKcal / C.DRY_KCAL_PER_GRAM, wet: 0 };
    }
    if (foodType === 'Wet Food') {
      return { dry: 0, wet: totalKcal / C.WET_KCAL_PER_GRAM };
    }
    // Wet + Dry — 50/50 calorie split
    var half = totalKcal / 2;
    return {
      dry: half / C.DRY_KCAL_PER_GRAM,
      wet: half / C.WET_KCAL_PER_GRAM
    };
  }

  function getVariantGrams(variantTitle, type) {
    var title = (variantTitle || '').toLowerCase();
    if (type === 'dry') {
      var kg = title.match(/([\d.]+)\s*kg/);
      if (kg) return parseFloat(kg[1]) * 1000;
    } else {
      var packs = title.match(/(\d+)\s*pack/);
      if (packs) return parseInt(packs[1], 10) * C.WET_TRAY_GRAMS;
    }
    return null;
  }

  function getDaysLasting(totalGrams, gramsPerDay) {
    if (!gramsPerDay || gramsPerDay <= 0) return 0;
    return Math.floor(totalGrams / gramsPerDay);
  }

  function getWeeksLasting(totalGrams, gramsPerDay) {
    var days = getDaysLasting(totalGrams, gramsPerDay);
    return Math.floor(days / 7);
  }

  return {
    calculateRER: calculateRER,
    getMERFactor: getMERFactor,
    calculateTotalKcal: calculateTotalKcal,
    calculateGramsPerDay: calculateGramsPerDay,
    getVariantGrams: getVariantGrams,
    getDaysLasting: getDaysLasting,
    getWeeksLasting: getWeeksLasting
  };

}(FGQ_CONSTANTS));

/* ---------------------------------------------------------------------------
   FeedingGuideQuiz — main class
   --------------------------------------------------------------------------- */

function FeedingGuideQuiz(container) {
  this.container = container;
  this.sectionId = container.dataset.sectionId || '';
  this.overlay   = container.querySelector('.fgq__overlay');
  this.modal     = container.querySelector('.fgq__modal');
  this.currentStep = 1;
  this.data = {};
  this.config = window['FGQ_CONFIG_' + this.sectionId] || {};
  this._init();
}

FeedingGuideQuiz.prototype._init = function () {
  this._bindOpen();
  this._bindClose();
  this._bindNavigation();
  this._bindOptionCards();
  this._bindSteppers();
  this._clearErrorsOnInput();
};

/* — Open ------------------------------------------------------------------ */

FeedingGuideQuiz.prototype._bindOpen = function () {
  var self = this;

  // Trigger buttons inside the section
  document.querySelectorAll('.js-fgq-open').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
  });

  // External trigger: any element with [data-fgq-section="<sectionId>"]
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-fgq-section]');
    if (el && el.dataset.fgqSection === self.sectionId) {
      e.preventDefault();
      self.open();
    }
  });
};

FeedingGuideQuiz.prototype.open = function () {
  this.overlay.classList.add('fgq__overlay--active');
  this.overlay.setAttribute('aria-hidden', 'false');
  document.body.classList.add('fgq-open');
  this._goToStep(1);
  // Defer focus so the step is visible
  var self = this;
  requestAnimationFrame(function () {
    var first = self.modal.querySelector('input, button:not(.fgq__close)');
    if (first) first.focus();
  });
};

/* — Close ----------------------------------------------------------------- */

FeedingGuideQuiz.prototype._bindClose = function () {
  var self = this;

  var closeBtn = this.container.querySelector('.js-fgq-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () { self.close(); });
  }

  var backdrop = this.container.querySelector('.js-fgq-backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', function () { self.close(); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && self._isOpen()) self.close();
  });
};

FeedingGuideQuiz.prototype.close = function () {
  this.overlay.classList.remove('fgq__overlay--active');
  this.overlay.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('fgq-open');
};

FeedingGuideQuiz.prototype._isOpen = function () {
  return this.overlay.classList.contains('fgq__overlay--active');
};

/* — Navigation ------------------------------------------------------------ */

FeedingGuideQuiz.prototype._bindNavigation = function () {
  var self = this;

  this.container.querySelectorAll('.js-fgq-next').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.dataset.step, 10);
      self._handleNext(step);
    });
  });

  this.container.querySelectorAll('.js-fgq-back').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.dataset.step, 10);
      self._goToStep(step - 1);
    });
  });
};

FeedingGuideQuiz.prototype._handleNext = function (step) {
  if (!this._validateStep(step)) return;
  this._collectData(step);
  if (step === 4) {
    this._calculateAndRenderResults();
    this._goToStep(5);
  } else {
    this._goToStep(step + 1);
  }
};

FeedingGuideQuiz.prototype._goToStep = function (n) {
  var self = this;
  this.container.querySelectorAll('.fgq__step').forEach(function (el) {
    el.classList.remove('fgq__step--active');
  });

  var target = this.container.querySelector('.fgq__step[data-step="' + n + '"]');
  if (!target) return;

  target.classList.add('fgq__step--active');
  this.currentStep = n;
  this._updateProgress(n);

  // Scroll modal to top
  if (this.modal) this.modal.scrollTop = 0;
};

FeedingGuideQuiz.prototype._updateProgress = function (step) {
  var progressEl = this.container.querySelector('.fgq__progress');
  if (!progressEl) return;

  // Hide dots on results step
  if (step === 5) {
    progressEl.style.visibility = 'hidden';
  } else {
    progressEl.style.visibility = '';
  }

  this.container.querySelectorAll('.fgq__dot').forEach(function (dot) {
    var dotStep = parseInt(dot.dataset.step, 10);
    dot.classList.toggle('fgq__dot--active', dotStep === step);
    dot.classList.toggle('fgq__dot--done', dotStep < step);
  });
};

/* — Validation ------------------------------------------------------------ */

FeedingGuideQuiz.prototype._validateStep = function (step) {
  var stepEl = this.container.querySelector('.fgq__step[data-step="' + step + '"]');
  var valid = true;
  var firstInvalid = null;

  // Clear previous errors
  stepEl.querySelectorAll('.fgq__error').forEach(function (el) { el.textContent = ''; });
  stepEl.querySelectorAll('.fgq__field--error').forEach(function (el) { el.classList.remove('fgq__field--error'); });
  stepEl.querySelectorAll('.fgq__options--error').forEach(function (el) { el.classList.remove('fgq__options--error'); });

  var self = this;

  if (step === 1) {
    var name = stepEl.querySelector('input[name="name"]');
    if (!name.value.trim()) {
      self._setFieldError(name, "Please enter your dog's name");
      if (!firstInvalid) firstInvalid = name;
      valid = false;
    }

    var breed = stepEl.querySelector('input[name="breed"]');
    if (!breed.value.trim()) {
      self._setFieldError(breed, "Please enter your dog's breed");
      if (!firstInvalid) firstInvalid = breed;
      valid = false;
    }

    var age = stepEl.querySelector('input[name="age"]');
    if (!age.value || parseFloat(age.value) <= 0) {
      self._setFieldError(age, 'Please enter a valid age');
      if (!firstInvalid) firstInvalid = age;
      valid = false;
    }

    var weight = stepEl.querySelector('input[name="weight"]');
    if (!weight.value || parseFloat(weight.value) < 1) {
      self._setFieldError(weight, 'Weight must be at least 1 kg');
      if (!firstInvalid) firstInvalid = weight;
      valid = false;
    }

    var neuteredChecked = stepEl.querySelector('input[name="neutered"]:checked');
    if (!neuteredChecked) {
      var fieldset = stepEl.querySelector('fieldset');
      if (fieldset) {
        fieldset.classList.add('fgq__field--error');
        var errEl = fieldset.querySelector('.fgq__error');
        if (errEl) errEl.textContent = 'Please select an option';
        if (!firstInvalid) firstInvalid = fieldset.querySelector('input[name="neutered"]');
      }
      valid = false;
    }

  } else if (step === 2) {
    if (!stepEl.querySelector('input[name="activity"]:checked')) {
      self._setOptionsError(stepEl, 'activity', 'Please select an option');
      valid = false;
    }

  } else if (step === 3) {
    if (!stepEl.querySelector('input[name="body_condition"]:checked')) {
      self._setOptionsError(stepEl, 'body_condition', 'Please select an option');
      valid = false;
    }

  } else if (step === 4) {
    if (!stepEl.querySelector('input[name="food_type"]:checked')) {
      self._setOptionsError(stepEl, 'food_type', 'Please select an option');
      valid = false;
    }
  }

  if (firstInvalid) {
    try { firstInvalid.focus(); } catch (e) {}
  }

  return valid;
};

FeedingGuideQuiz.prototype._setFieldError = function (input, message) {
  var field = input.closest('.fgq__field, .fgq__stepper');
  if (field) {
    var wrapper = field.closest('.fgq__field') || field;
    wrapper.classList.add('fgq__field--error');
    var errEl = wrapper.querySelector('.fgq__error');
    if (errEl) errEl.textContent = message;
  }
};

FeedingGuideQuiz.prototype._setOptionsError = function (stepEl, name, message) {
  var opts = stepEl.querySelector('.fgq__options[data-group="' + name + '"]');
  if (opts) opts.classList.add('fgq__options--error');
  var errEl = stepEl.querySelector('.fgq__options-error[data-group="' + name + '"]');
  if (errEl) errEl.textContent = message;
};

FeedingGuideQuiz.prototype._clearErrorsOnInput = function () {
  var self = this;

  this.container.querySelectorAll('.fgq__input').forEach(function (input) {
    input.addEventListener('input', function () {
      var field = input.closest('.fgq__field');
      if (field) {
        field.classList.remove('fgq__field--error');
        var err = field.querySelector('.fgq__error');
        if (err) err.textContent = '';
      }
    });
  });

  this.container.querySelectorAll('.fgq__option-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var opts = self.container.querySelector('.fgq__options[data-group="' + input.name + '"]');
      if (opts) opts.classList.remove('fgq__options--error');
      var err = self.container.querySelector('.fgq__options-error[data-group="' + input.name + '"]');
      if (err) err.textContent = '';
    });
  });

  this.container.querySelectorAll('input[name="neutered"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var fs = input.closest('fieldset');
      if (fs) {
        fs.classList.remove('fgq__field--error');
        var err = fs.querySelector('.fgq__error');
        if (err) err.textContent = '';
      }
    });
  });
};

/* — Data collection ------------------------------------------------------- */

FeedingGuideQuiz.prototype._collectData = function (step) {
  var stepEl = this.container.querySelector('.fgq__step[data-step="' + step + '"]');

  if (step === 1) {
    this.data.name         = stepEl.querySelector('input[name="name"]').value.trim();
    this.data.breed        = stepEl.querySelector('input[name="breed"]').value.trim();
    this.data.age          = parseFloat(stepEl.querySelector('input[name="age"]').value);
    this.data.weight       = parseFloat(stepEl.querySelector('input[name="weight"]').value);
    this.data.neutered     = stepEl.querySelector('input[name="neutered"]:checked').value;
  } else if (step === 2) {
    this.data.activity     = stepEl.querySelector('input[name="activity"]:checked').value;
  } else if (step === 3) {
    this.data.bodyCondition = stepEl.querySelector('input[name="body_condition"]:checked').value;
  } else if (step === 4) {
    this.data.foodType     = stepEl.querySelector('input[name="food_type"]:checked').value;
  }
};

/* — Option card visual highlight ------------------------------------------ */

FeedingGuideQuiz.prototype._bindOptionCards = function () {
  var self = this;

  this.container.querySelectorAll('.fgq__option-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var name = input.name;
      self.container.querySelectorAll('.fgq__option[data-group="' + name + '"]').forEach(function (opt) {
        opt.classList.remove('fgq__option--selected');
      });
      var parentOpt = input.closest('.fgq__option');
      if (parentOpt) parentOpt.classList.add('fgq__option--selected');
    });
  });
};

/* — Stepper controls ------------------------------------------------------ */

FeedingGuideQuiz.prototype._bindSteppers = function () {
  this.container.querySelectorAll('.fgq__stepper-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var stepper = btn.closest('.fgq__stepper');
      if (!stepper) return;
      var input   = stepper.querySelector('input[type="number"]');
      if (!input)  return;

      var stepVal = parseFloat(input.step) || 1;
      var min     = input.min !== '' ? parseFloat(input.min) : 0;
      var max     = input.max !== '' ? parseFloat(input.max) : 999;
      var current = parseFloat(input.value) || 0;

      if (btn.classList.contains('fgq__stepper-btn--plus')) {
        current = Math.min(current + stepVal, max);
      } else {
        current = Math.max(current - stepVal, min);
      }

      input.value = current;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
};

/* — Calculate & render results -------------------------------------------- */

FeedingGuideQuiz.prototype._calculateAndRenderResults = function () {
  var d = this.data;

  var totalKcal = FeedingCalculator.calculateTotalKcal(
    d.weight, d.bodyCondition, d.neutered, d.activity
  );

  if (totalKcal === null) {
    console.error('[FGQ] Could not calculate kcal — check MER table inputs');
    return;
  }

  var grams = FeedingCalculator.calculateGramsPerDay(totalKcal, d.foodType);
  this.data.totalKcal = totalKcal;
  this.data.dryGpd    = grams.dry;
  this.data.wetGpd    = grams.wet;

  this._renderResults();
};

FeedingGuideQuiz.prototype._renderResults = function () {
  var d      = this.data;
  var config = this.config;

  // Resolve products based on food type
  var dryProduct = (d.foodType === 'Dry Food' || d.foodType === 'Wet + Dry') ? config.dryProduct : null;
  var wetProduct = (d.foodType === 'Wet Food' || d.foodType === 'Wet + Dry') ? config.wetProduct : null;

  // Dog name heading
  this.container.querySelectorAll('.js-fgq-dog-name').forEach(function (el) {
    el.textContent = d.name.toUpperCase() + ' NEEDS:';
  });

  // Daily amounts
  var amountsEl = this.container.querySelector('.js-fgq-amounts');
  if (amountsEl) {
    amountsEl.innerHTML = this._renderAmountsHTML(d.foodType, d.dryGpd, d.wetGpd);
  }

  // Summary text
  var summaryEl = this.container.querySelector('.js-fgq-summary');
  if (summaryEl) {
    summaryEl.textContent = this._buildSummaryText(d.name, d.foodType, d.dryGpd, d.wetGpd);
  }

  // Product cards
  var productsEl = this.container.querySelector('.js-fgq-products');
  if (productsEl) {
    productsEl.innerHTML = this._renderProductCardsHTML(d.foodType, dryProduct, wetProduct, d.dryGpd, d.wetGpd);
  }

  // Bind ATC buttons
  this._bindATCButtons();
};

FeedingGuideQuiz.prototype._renderAmountsHTML = function (foodType, dryGpd, wetGpd) {
  var html = '';
  var config = this.config;
  var dryBowl = config.dryBowlImage || '';
  var wetBowl = config.wetBowlImage || '';

  if (foodType === 'Dry Food' || foodType === 'Wet + Dry') {
    html += '<div class="fgq__amount-item">'
      + (dryBowl ? '<div class="fgq__amount-image"><img src="' + dryBowl + '" alt="Dry food bowl" loading="lazy" width="72" height="72"></div>'
                 : '<div class="fgq__amount-bowl fgq__amount-bowl--dry" aria-hidden="true"></div>')
      + '<div class="fgq__amount-info">'
      + '<span class="fgq__amount-grams">' + Math.round(dryGpd) + '<span class="fgq__amount-unit">g</span></span>'
      + '<span class="fgq__amount-label">DRY FOOD<br>PER DAY</span>'
      + '</div></div>';
  }

  if (foodType === 'Wet Food' || foodType === 'Wet + Dry') {
    html += '<div class="fgq__amount-item">'
      + (wetBowl ? '<div class="fgq__amount-image"><img src="' + wetBowl + '" alt="Wet food bowl" loading="lazy" width="72" height="72"></div>'
                 : '<div class="fgq__amount-bowl fgq__amount-bowl--wet" aria-hidden="true"></div>')
      + '<div class="fgq__amount-info">'
      + '<span class="fgq__amount-grams">' + Math.round(wetGpd) + '<span class="fgq__amount-unit">g</span></span>'
      + '<span class="fgq__amount-label">WET FOOD<br>PER DAY</span>'
      + '</div></div>';
  }

  return html;
};

FeedingGuideQuiz.prototype._buildSummaryText = function (name, foodType, dryGpd, wetGpd) {
  var dryKg = (dryGpd * 30 / 1000).toFixed(2);
  var wetGCalc = (wetGpd * 30 / 390);
  var wetG = (wetGCalc % 1 === 0) ? String(wetGCalc.toFixed(0)) : wetGCalc.toFixed(2);
  if (foodType === 'Dry Food') {
    return name + ' will eat roughly ' + dryKg + 'kg of dry food every 30 days.';
  }
  if (foodType === 'Wet Food') {
    return name + ' will eat roughly ' + wetG + ' cartons of wet food every 30 days.';
  }
  return name + ' will eat roughly ' + dryKg + 'kg dry food and ' + wetG + ' cartons of wet food every 30 days.';
};

FeedingGuideQuiz.prototype._renderProductCardsHTML = function (foodType, dryProduct, wetProduct, dryGpd, wetGpd) {
  var html = '';
  var C = FGQ_CONSTANTS;
  var indices = C.FOOD_TYPE_VARIANTS[foodType] || { dry: [], wet: [] };

  if (foodType === 'Wet + Dry') {
    html += '<div class="fgq__product-section">'
      + '<h4 class="fgq__product-section-title">Dry Food</h4>'
      + this._renderVariantCards(dryProduct, 'dry', dryGpd, indices.dry, C.DRY_BADGES)
      + '</div>';

    html += '<div class="fgq__product-section">'
      + '<h4 class="fgq__product-section-title">Wet Food</h4>'
      + this._renderVariantCards(wetProduct, 'wet', wetGpd, indices.wet, {})
      + '</div>';

  } else if (foodType === 'Dry Food') {
    html += '<div class="fgq__product-section">'
      + this._renderVariantCards(dryProduct, 'dry', dryGpd, indices.dry, C.DRY_BADGES)
      + '</div>';

  } else {
    html += '<div class="fgq__product-section">'
      + this._renderVariantCards(wetProduct, 'wet', wetGpd, indices.wet, C.DRY_BADGES)
      + '</div>';
  }

  return html;
};

FeedingGuideQuiz.prototype._renderVariantCards = function (product, type, gramsPerDay, indices, badges) {
  if (!product || !Array.isArray(product.variants)) return '';
  var self = this;
  var html = '';
  product.variants.forEach(function (variant, i) {

    if (indices.indexOf(i) === -1) return;

    var totalGrams = FeedingCalculator.getVariantGrams(variant.title, type);
    if (!totalGrams) return;

    var days  = FeedingCalculator.getDaysLasting(totalGrams, gramsPerDay);
    var weeks = FeedingCalculator.getWeeksLasting(totalGrams, gramsPerDay);
    var badge = badges[i] || null;

    var subPrice = (typeof variant.subscriptionPrice === 'number') ? variant.subscriptionPrice : null;

    if(product.handle == "all-day-buffet") {
      subPrice = variant.price * 0.9;
    }
    var dailyCost = (subPrice !== null && days > 0) ? self._formatMoney(Math.round(subPrice / days)) : null;
    var imgSrc    = variant.image || product.image || '';

    html += self._renderSingleCard(variant, product, badge, weeks, dailyCost, imgSrc);
  });

  return html;
};

FeedingGuideQuiz.prototype._renderSingleCard = function (variant, product, badge, weeks, dailyCost, imgSrc) {
  var badgeHtml = badge
    ? '<div class="fgq__product-badge fgq__product-badge--' + (badge === 'Most Popular' ? 'popular' : 'value') + '">'
      + badge + '</div>'
    : '';

  var imgHtml = imgSrc
    ? '<img src="' + this._escapeHtml(imgSrc) + '" alt="' + this._escapeHtml(variant.title) + '" loading="lazy" width="60" height="60">'
    : '';

  var weekLabel = weeks === 0 ? 'week' : 'weeks';

  var dailyHtml = dailyCost
    ? '<div class="fgq__product-daily">' + dailyCost + ' per day <span>on subscription</span></div>'
    : '';

  var productUrl = product.url
    ? product.url + '?variant=' + variant.id
    : '/products/' + (product.handle || '');

  return '<div class="fgq__product-card">'
   
    + '<div class="fgq__product-card-inner">'
    + '<div class="fgq__product-image">' + imgHtml + '</div>'
    + '<div class="fgq__product-info">'
    + badgeHtml
    + '<span class="fgq__product-size">' + this._escapeHtml(variant.title) + '</span>'
    
    + '</div>'
    + '<div class="fgq__product-actions">'
    + '<div class="fgq__product-duration">Lasts <strong>' + weeks + ' - '+ (weeks + 1) + ' ' + weekLabel + '</strong></div>'
    + dailyHtml
    + '</div>'
    + '</div>'
    + '</div>';
};

/* — Add to cart ------------------------------------------------------------ */

FeedingGuideQuiz.prototype._bindATCButtons = function () {
  var self = this;

  this.container.querySelectorAll('.js-fgq-atc').forEach(function (btn) {
    // Remove old listeners by cloning
    var fresh = btn.cloneNode(true);
    btn.parentNode.replaceChild(fresh, btn);

    fresh.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId    = fresh.dataset.variantId;
      var sellingPlan  = fresh.dataset.sellingPlan || null;
      if (variantId) self._addToCart(variantId, sellingPlan, fresh);
    });
  });
};

FeedingGuideQuiz.prototype._addToCart = function (variantId, sellingPlanId, btn) {
  var self = this;
  var originalText = btn ? btn.textContent : '';

  if (btn) {
    btn.textContent = 'Adding…';
    btn.disabled = true;
  }

  var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
  if (sellingPlanId) {
    body.items[0].selling_plan = parseInt(sellingPlanId, 10);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  })
  .then(function (res) {
    if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
    return res.json();
  })
  .then(function () {
    if (btn) {
      btn.textContent = 'Added ✓';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2500);
    }

    // Open Rebuy SmartCart if available
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      window.Rebuy.SmartCart.show();
    }

    // Refresh cart count across the theme
    document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
  })
  .catch(function (err) {
    console.error('[FGQ] Add to cart error:', err);
    if (btn) {
      btn.textContent = 'Error — try again';
      btn.disabled = false;
    }
  });
};

/* — Helpers --------------------------------------------------------------- */

FeedingGuideQuiz.prototype._formatMoney = function (pence) {
  if (typeof pence !== 'number' || isNaN(pence)) return '—';
  return '£' + (pence / 100).toFixed(2);
};

FeedingGuideQuiz.prototype._escapeHtml = function (str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

/* ---------------------------------------------------------------------------
   Initialise all quiz instances on the page
   --------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-fgq-section').forEach(function (container) {
    new FeedingGuideQuiz(container);
  });
});
